/**
 * @fileoverview GET handler for the "/apps/business/account_fields" endpoint
 */
import fetch from "@lib/fetch";

import { reactQueryFetcherAdapter } from "../reactQueryFetcherAdapters";
import { legacyCatalogAccountFields } from "./constants";
import type { LegacyCatalogAccountFieldsResult } from "./types";
import { isLegacyCatalogAccountFieldsResult } from "./validators";

export const getLegacyCatalogAccountFields = reactQueryFetcherAdapter(
  legacyCatalogAccountFields,
  (signal: AbortSignal): Promise<LegacyCatalogAccountFieldsResult> => {
    return fetch("/apps/business/account_fields", "GET", {}, { signal }, { propagateFetchRequestError: false });
  },
  isLegacyCatalogAccountFieldsResult
);
